import type { EmblaOptionsType } from 'embla-carousel';
import { EmblaCarousel } from './EmblaCarousel';
import { portfolioData } from './Portfolio.data';
import {
  StyledFrame,
  StyledHeadline,
  StyledHeadlineDescription,
  StyledHeadlineWrapper,
  StyledSection,
  StyledStack,
} from './styles';

const OPTIONS: EmblaOptionsType = { loop: true };
const SLIDE_COUNT = portfolioData.examples.length;
const SLIDES = Array.from(Array(SLIDE_COUNT).keys());

export const Portfolio = () => {
  return (
    <StyledSection width="normal">
      <StyledStack>
        <StyledFrame>
          <StyledHeadlineWrapper>
            <StyledHeadline variant="display_sm">
              {portfolioData.mainText}
            </StyledHeadline>
            <StyledHeadlineDescription variant="strong_400">
              {portfolioData.description}
            </StyledHeadlineDescription>
          </StyledHeadlineWrapper>
          <EmblaCarousel slides={SLIDES} options={OPTIONS} />
        </StyledFrame>
      </StyledStack>
    </StyledSection>
  );
};
